import image1 from "./assets/image1.png";
import image2 from "./assets/image2.png";
import image3 from "./assets/image3.png";
import Icon from "./assets/Icon.png";
import Icon1 from "./assets/Icon 1.png";
import Icon2 from "./assets/Icon 2.png";
import Icon3 from "./assets/Icon 3.png";
import image16 from "./assets/image16.png";
import image17 from "./assets/image17.png";
import image18 from "./assets/image18.png";
import image19 from "./assets/image19.png";


export const imagearray1=[
    { 
        src:image1,
        title:"Skper Pool Apartment",
        cost: "$2,80000",
        location: "1020 Bloomingdal Ave"
    },
    {
        src:image2,
        title:"North Dillard Street",
        cost: "$250/month",
        location: "4330 Bell Shoals Rd",

    },
    {
        src :image3,
        title:"Eaton Garth Penthouse",
        cost:"$180000",
        location:"7722 18th Ave; Brooklyn"

    }
]

export const IconArray = [
    {
        src:Icon,
        title:"Find your future home",
        desc:"We help you find a new home by offering a smart real estate experience"

    },
    {
        src: Icon1,
        title:"Experienced agents",
        desc: "Find an experienced agent who knows your market best"
    },
    {
        src:Icon2,
        title:"Buy or rent homes",
        desc:"Millions of houses and apartments in your favourite cities" 
    },
    {
        src:Icon3,
        title:"List your own property",
        desc:"Sign up now and sell or rent your own properties "
    }
]

export const ArticlesArray = [
    {
        src:image16,
        desc:"Apartment . March19, 2024 ",
        title:"Housing Markets That Changed the Most This Week"

    },
    {
        src:image17,
        desc:"Apartment . March19, 2024 ",
        title:"Read Unveils the Best Canadian Cities for Biking",

    },
    {
        src:image18,
        desc:"Office . March19, 2024 ",
        title:"10 Walkable Cities Where You Can Live Affordably"
    },
    {
        src:image19,
        desc:"Shop . March19, 2024 ",
        title:"New Apartment Nice in the Best Canadian Cities"
    }
]

export const data1=[
    {
        data:"Real Estate NY",

    },
    {
        data:"Real Estate Brooklyn",

    },
    {
        data:"Real Estate Queens",
    },
    {
        data:"Real Estate Bronx",
    },
    {
        data:"Real Estate Staten",

    },
    {
        data:"Real Estate Staten jersey"
    }
]
 export const data2=[
    {
        data:"Real Estate Norwalk",
    },
    {
        data:"Real Estate Stamford",
    },
    {
        data:"Real Estate Greenwich",
    },
    {
        data:"Real Estate Darien",
    },
    {
        data:"Real Estate New Canaan",
    },
    {
        data:"Real Estate Westport",
    }
 ]

 export const data3 = [
    {
        data:"Real Estate NY",

    },
    {
        data:"Real Estate Brooklyn",
    },
    {
        data:"Real Estate Chicago"
    },
    {
        data:"Real Estate Queens"
    },
    {
        data:"Real Estate Bronx"
    },
    {
        data:"Real Estate Staten"
    }

 ]
  export const data4 = [
    {
        data:"Real Estate NY",
    },
    {
        data:"Real Estate Brooklyn",
    },
    {
        data:"Real Estate Chicago"
    },
    {
        data:"Real Estate Queens"
    },
    {
        data:"Real Estate Bronx"
    },
    {
        data:"Real Estate Staten"
    }
  ]
   export const data5 = [
    {
        data:"Real Estate NY",
    },
    {
        data:"Real Estate Brooklyn",
    },
    {
        data:"Real Estate Chicago"
    },
    {
        data:"Real Estate Queens"
    },
    {
        data:"Real Estate Bronx"
    },
    {
        data:"Real Estate Staten"
    }

   ]
    export const data6 = [
        {
            data:"Real Estate NY",
        },
        {
            data:"Real Estate Brooklyn",
        },
        {
            data:"Real Estate Chicago"
        },
        {
            data:"Real Estate Queens"
        },
        {
            data:"Real Estate Bronx"
        },
        {
            data:"Real Estate Staten"
        }

    ]
     